module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his book started about three years ago. My husband and I were having coffee with our good friends Anita and Barry. Anita, who came to England as a child refugee in the 1930s, mentioned that her husband, who was ten years old when the war ended, did not really know anything about what had happened to me during the Holocaust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After a few moments of hesitation, I slowly started to recount some of my experiences. Their questions were so keen, their interest so deep and yet their knowledge of those times appeared so small, that I found myself going into details, some of which I had not revealed to anyone before and had, in fact, suppressed for many years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the end of the evening we were all in tears and almost speechless with emotion. My friends were shocked at the thought of how remote most people now are from those events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They — and my husband — urged me to write my story. This thought pursued me in the weeks that followed. It gave rise to others: I let my life pass in front of me. In spite of what had happened to me during the war I have no feelings of bitterness or hate, but on the other hand I do not believe in the goodness of man.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("My posthumous step-sister, Anne Frank, wrote in her "), _c('em', [_vm._v("Diary:")]), _vm._v(" “I still believe that deep down human beings are good at heart.” I cannot help remembering that she wrote this "), _c('em', [_vm._v("before")]), _vm._v(" she experienced Auschwitz and Belsen.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throughout the terrible years I had felt that I was being protected by an all-powerful being, but that source of assurance had begun to give way to some troubling questions. Why had I been spared and not millions of others, including my brother and father? Was the world improving as a result of its experience of mass annihilation? Was it not necessary to tell that story again and again and to look at it from every angle? How much time was left for the handful of survivors, before their unimaginable memories, which only they could bring to life, would be forgotten? Did not I and the other survivors owe a duty to the millions of victims to make it less likely that their deaths had been in vain?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I became convinced that if I could move only a handful of people to care more for their fellow man, I would achieve something worthwhile and that it was my duty to try to do just that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I decided to approach my friend Evelyn Kent to help me write the story of my Holocaust experiences. I had not said more than a few words when she interrupted me and said: “Eva, I’ve been waiting ever since I first met you twenty years ago, to write your story.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That is how we came to write this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775c4294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Preface.vue
// module id = 78
// module chunks = 0